<template>
  <div>
    <b-form-select
      v-if="Options.length < 10"
      v-model="item"
      :disabled="disabled"
      :options="Options"
      @change="onChange($event)"
      :state="state"
    ></b-form-select>
    <v-select-s
      v-if="Options.length >= 10"
      dir="rtl"
      :value="value"
      :disabled="disabled"
      :reduce="(item) => item.value"
      @input="onChange"
      :options="Options"
      :autocomplete="'on'"
      label="text"
    >
      <template v-slot:no-options="{ search, searching }">
        <template v-if="searching">
          موردی برای "<em>{{ search }}</em
          >" یافت نشد
        </template>
      </template>
    </v-select-s>
  </div>
</template>
<style>
.vs--searchable .vs__dropdown-toggle {
  padding: 6px;
  border: 1px solid #e5eaee;
}
.vs--disabled .vs__clear,
.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__open-indicator,
.vs--disabled .vs__search,
.vs--disabled .vs__selected {
  background-color: #f3f6f9;
  border: 1px solid #e5eaee;
}
.vs__selected {
  border: 0px !important;
}
.vs__search,
.vs__search:focus {
  border: 0px !important;
}
</style>
<script>
import httpHelper from "../helpers/httpHelper";
import sessionHelper from "../helpers/sessionHelper";
import vSelect from "vue-select";
export default {
  name: "MDDropdown",
  props: ["group", "value", "parent", "state", "disabled", "change","type"],
  components: {
    "v-select-s": vSelect,
  },
  data: function() {
    return {
      data: [],
      Options: [],
      item: null,
      isDesabled: false,
    };
  },
  watch: {
    value: function(newVal, oldVal) {
      this.item = this.value;
    },
    parent: function(newVal, oldVal) {
      this.getOptions();
    },
    disabled: function(newVal, oldVal) {
      ///this.isDesabled = true;
    },
  },
  mounted() {
    httpHelper
      .getData("metadata?metadata_group_id=" + this.group)
      .then((res) => {
        switch (this.type) {
          case "dollar":
            res.result=res.result.filter(v=>v.title==="دلار")
            break;
          case "rial":
            res.result=res.result.filter(v=>v.title==="ریال")
            break;
        
          default:
            break;
        }
        this.data = res.result.map((element) => {
          return {
            parent: element.parent_id,
            value: element.id,
            text: element.title,
          };
        });
        if (this.value) this.item = this.value;
        this.getOptions();
      });
  },
  methods: {
    onChange(event) {
      this.$emit("input", event);
      if (this.change) {
        this.change();
      }
    },
    getOptions() {
      if (this.parent != null && this.parent != 0) {
        this.Options = [];
        this.data.forEach((element) => {
          if (element.parent == this.parent) {
            this.Options.push(element);
          }
        });
      } else {
        this.Options = this.data;
      }
    },
  },
};
</script>
